var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showing == "web_awesome" && _vm.icon
    ? _c(
        "div",
        {
          attrs: {
            id: "code-snippet-web_awesome",
            role: "tabpanel",
            "aria-labelledby": "tab-web_awesome",
          },
        },
        [
          _c("wa-code-block", {
            attrs: {
              "add-highlighting": "",
              "allow-shadow-copy": "",
              "copy-text": "Copy Code Snippet",
              "custom-copy-icon": "faClone",
              "copy-tracking-event": "icon_web_awesome_code_copy_button_click",
              "copy-tracking-params": {
                icon_name: _vm.icon.name,
                icon_style: _vm.styling.style,
                icon_family: _vm.styling.family,
              },
              lang: "markup",
              code: _vm.generatedCodeSnippet,
            },
          }),
          _vm._v(" "),
          _c("icon-code-snippet-links", {
            attrs: {
              links: _vm.allWebAwesomeLinks,
              "selected-style": _vm.styling.style,
              "major-version": _vm.majorVersion,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }